<template>
  <div>
    <div  style="width: 1300px; margin:  0 auto" v-if="type === '报关单'">
      <el-button @click="print" type="primary">打印</el-button>
      <h1 style="text-align: center; font-size: 26px">中华人民共和国海关出口货物报关单</h1>
      <div class="tipsTop">
        <span>预录入编号：254754125475145</span>
        <span>海关编号：254754125475145</span>
        <span>（海沧港区）</span>
        <span>仅供核对用</span>
      </div>
      <div class="bill" >
      <el-row>
        <el-col :span="7">
          <div class="item">
            <h1>境内发货人</h1><span>{{detail.contact_contactid_company_show}}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="item">
            <h1>出境关别</h1><span>{{detail.access_port}}</span>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item">
            <h1>出口日期</h1><span>{{detail.sailschedule}}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="item">
            <h1>申报日期</h1><span>{{detail.receiver.receiverid_company_show}}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="item">
            <h1>备案号</h1><span></span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="7">
          <div class="item">
            <h1>境外收货人</h1><span> {{detail.receiver_receiverid_company_show}}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="item">
            <h1>运输方式</h1><span>{{detail.shipping_type}}</span>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item">
            <h1>运输工具名称及航次号</h1><span>{{detail.conveyance_name}} {{detail.voyage_number}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item">
            <h1>提运单号</h1><span>{{detail.loading_bill_number}}</span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="7">
          <div class="item">
            <h1>生产销售单位</h1><span></span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="item">
            <h1>监管方式</h1><span>{{detail.trade_approach}}</span>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item">
            <h1>征免性质</h1><span></span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item">
            <h1>许可证号</h1><span></span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="7">
          <div class="item">
            <h1>合同协议号</h1><span>{{detail.contract_type_info_contractno}}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="item">
            <h1>贸易国(地区)</h1><span>{{detail.trade_country}}</span>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item">
            <h1>运抵国(地区)</h1><span>{{detail.destcountry}}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="item">
            <h1>指运港</h1><span>{{detail.loading_port}}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="item">
            <h1>离境口岸</h1><span>{{detail.leave_Port}}</span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="7">
          <div class="item">
            <h1>包装种类</h1><span>{{detail.package1_package}}</span>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="item">
            <h1>件数</h1><span>{{detail.packcount}}</span>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="item">
            <h1>毛重(千克)</h1><span>{{detail.gwkg}}</span>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="item">
            <h1>净重(千克)</h1><span>{{detail.nwkg}}</span>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="item">
            <h1>成交方式</h1><span>{{detail.priceterm_info_type}}</span>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="item">
            <h1>运费</h1><span>{{detail.priceterm_info_fare}}</span>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="item">
            <h1>保费</h1><span>{{detail.priceterm_info_premium}}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="item">
            <h1>杂费</h1><span> {{ priceterm_info_incidental}}</span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div class="item">
            <h1>随附单证及编号</h1><span></span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div class="item">
            <h1>标记唛码及备注</h1><span>{{detail.marks}}</span>
          </div>
        </el-col>
      </el-row>

      <el-table :data="tableData" class="table">
        <el-table-column prop="index" label="项号"></el-table-column>
        <el-table-column prop="hscode" label="商品编号"></el-table-column>
        <el-table-column prop="ch" label="商品名称"></el-table-column>
        <el-table-column prop="factors" label="规格型号"></el-table-column>
        <el-table-column prop="qtt" label="数量"></el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
<!--        <el-table-column prop="address" label="数量及单位"></el-table-column>-->
        <el-table-column prop="singleprice" label="单价"></el-table-column>
        <el-table-column prop="tax_rep_amount" label="总价"></el-table-column>
        <el-table-column prop="currency" label="币制"></el-table-column>
        <el-table-column prop="address" label="原产国(地区)"></el-table-column>
        <el-table-column prop="destcountry" label="最终目的国(地区)"></el-table-column>
        <el-table-column prop="sourcearea" label="境内货源地"></el-table-column>
        <el-table-column prop="address" label="征免"></el-table-column>
      </el-table>

      <el-row>
        <el-col :span="6">
          <div class="item bottom">
            <h1>特殊关系确认：</h1><span>{{detail.special_relation}}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="item bottom">
            <h1>价格影响确认：</h1><span></span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="item bottom">
            <h1>支付特许权使用费确认：</h1><span>{{detail.special_pay_confirm}}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="item bottom">
            <h1>自报自缴：</h1><span></span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="16">
          <div class="signature_left">
            <div class="signature_left_text">
              <div>
                <h1>报关人员</h1><p></p>
              </div>
              <div>
                <h1>报关人员证号</h1><p></p>
              </div>
              <div>
                <h1>电话</h1><p></p>
              </div>
              <span>兹申明对以上内容承担如实申报、依法纳税之法律责任</span>
            </div>
            <div class="signature_left_chapter">
              <h1>申报单位</h1>
              <p>申报单位</p>
              <span>申报单位(签章)</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="signature_right">
            <h1>海关批注及签章</h1>
          </div>
        </el-col>
      </el-row>
      </div>
    </div>

    <div v-if="type === '放行单'" style="width: 1300px; margin:  0 auto">
      <el-button @click="print_fxd" type="primary">打印</el-button>
      <div class="header">
        <h1>通关无纸化出口放行通知书</h1>
        <p>福建泉州市中太进出口有限公司</p>
        <span>你公司以通关无纸化方式向海关发送下列电子报关单数据业经海关审核放行，请携带本通知书及 相关单证至港区办理装货/提货手续</span>
      </div>
      <div class="bill">
        <el-row>
          <el-col :span="6">
            <div class="item">
              <h1>出口关别((3711))</h1><span>{{detail.access_port}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>备案号</h1><span></span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>出口日期</h1><span>{{detail.sailschedule}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>申报日期</h1><span></span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <div class="item">
              <h1>收发货人</h1><span>{{detail.receiver_receiverid_company_show}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>运输方式(2)</h1><span>{{detail.shipping_type}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>运输工具名称</h1><span>{{detail.conveyance_name}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>提运单号</h1><span>{{detail.loading_bill_number}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <div class="item">
              <h1>生产销售单位(91350521775383684J)</h1><span></span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>监管方式 (0110)</h1><span>{{detail.trade_approach}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>征免性质 (101)</h1><span></span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>结汇方式</h1><span></span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <div class="item">
              <h1>许可证号 </h1><span> </span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>运抵国(地区)(IND)</h1><span>{{detail.destcountry}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>指运港(地区)(IND166)</h1><span>{{detail.loading_port}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item">
              <h1>境内货源地(35059)</h1><span></span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="item">
              <h1>批准文号</h1><span></span>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item">
              <h1>成交方式(3)</h1><span>{{detail.priceterm_info_type}}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="item">
              <h1>运费(IND166) </h1><span>{{detail.priceterm_info_fare}}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="item">
              <h1>保费(IND166) </h1><span>{{detail.priceterm_info_premium}} </span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="item">
              <h1>杂费(35059)</h1><span></span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="item">
              <h1>合同协议号</h1><span>{{detail.contract_type_info_contractno}}</span>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="item">
              <h1>件数</h1><span>{{detail.packcount}}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="item">
              <h1>包装种类</h1><span>{{detail.package1_package}}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="item">
              <h1>毛重（千克）</h1><span>{{detail.gwkg}}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="item">
              <h1>净重（千克）</h1><span>{{detail.nwkg}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="item">
              <h1>集装箱号</h1><span></span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <h1>随附单证</h1><span></span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <h1>生产厂家</h1><span></span>
            </div>
          </el-col>
        </el-row>

        <el-table :data="tableData" class="table">
          <el-table-column prop="index" label="项号"></el-table-column>
<!--          <el-table-column prop="hscode" label="商品编号"></el-table-column>-->
          <el-table-column prop="ch" label="商品名称"></el-table-column>
          <el-table-column prop="factors" label="规格型号"></el-table-column>
          <el-table-column prop="qtt" label="数量"></el-table-column>
          <el-table-column prop="unit" label="单位"></el-table-column>
          <el-table-column prop="address" label="原产国(地区)"></el-table-column>
          <!--        <el-table-column prop="address" label="数量及单位"></el-table-column>-->
          <el-table-column prop="singleprice" label="单价"></el-table-column>
<!--          <el-table-column prop="tax_rep_amount" label="总价"></el-table-column>-->
          <el-table-column prop="currency" label="币制"></el-table-column>

<!--          <el-table-column prop="destcountry" label="最终目的国(地区)"></el-table-column>-->
<!--          <el-table-column prop="sourcearea" label="境内货源地"></el-table-column>-->
<!--          <el-table-column prop="address" label="征免"></el-table-column>-->
        </el-table>

      </div>

      <div class="footer">
        <p>兹申明,以上通知由我公司根据海关电子回执打印,保证准确无讹。</p>
        <span>福建泉州市中太进出口有限公司(签印)</span>
        <i>2021年09月18日</i>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "print",
    data() {
      return {
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }],
        detail: "",
        priceterm_info: "",//价格条款（成交方式）
        type: ""
      }
    },
    created() {
      console.log(this.$route.query.type)
      this.type = this.$route.query.type

      this.$axios
        .get(`/admin/orderCheck/selectOrder?id=${this.$route.query.id}`)
        .then(res => {
          this.detail = res.data.info.order
          console.log(res.data.info)
          this.priceterm_info= JSON.parse(res.data.info.order.priceterm_info) ;
          this.detail.priceterm_info_type =JSON.parse(res.data.info.order.priceterm_info).type;
          this.detail.priceterm_info_fare =JSON.parse(res.data.info.order.priceterm_info).fare;
          this.detail.priceterm_info_premium =JSON.parse(res.data.info.order.priceterm_info).premium;

          this.detail.package1_package =JSON.parse(res.data.info.order.package1).package;
          this.detail.receiver_receiverid_company_show =JSON.parse(res.data.info.order.receiver).receiverid_company_show;
          this.detail.contact_contactid_company_show =JSON.parse(res.data.info.order.contact).contactid_company_show;
          this.detail.contract_type_info_contractno =JSON.parse(res.data.info.order.contract_type_info).contractno;

          if( res.data.info.order.special_relation==1){
            this.detail.special_relation ="是"
          }else if ( res.data.info.order.special_relation==2){
            this.detail.special_relation ="否"
          }
          if( res.data.info.order.special_pay_confirm==1){
            this.detail.special_pay_confirm ="是"
          }else if ( res.data.info.order.special_pay_confirm==2){
            this.detail.special_pay_confirm ="否"
          }
          this.tableData=res.data.info.products
          for(var n = 0; n <  this.tableData.length; n++) {
            this.tableData[n].index= n+1
            this.tableData[n].destcountry= this.detail.destcountry
          }

        });
    },
    mounted() {
      // setTimeout(() => {
      //   window.print()
      // })
    },
    methods:{
      print(){
        window.print()
      },
      print_fxd(){
        window.print()
      },
    }

  }
</script>

<style scoped>
  .bill {
    border: 1px solid #999999;
    width: 1300px;
    margin: 0 auto;
  }
  .item {
    padding: 2px;
    border: 1px solid #999999;
    height: 40px;
  }
  .item h1, .item span {
    font-size: 14px;
    color: #111111;
  }
  .table {
    width: 100%;
    border: 1px solid #999999;
    border-top: none;
  }
  .bottom {
    text-align: center;
    line-height: 40px;
  }
  .bottom h1 {
    display: inline;
  }
  .signature_left {
    border: 1px solid #999999;
    height: 60px;
    padding: 10px;
  }
  .signature_left h1, .signature_left p {
    font-size: 14px;
    color: #111111;
    float: left;
  }
  .signature_left_text {
    overflow: hidden;
  }

  .signature_left_text p {
    margin: 0 10px;
  }
  .signature_left_text span {
    float: right;
    font-size: 14px;
  }
  .signature_left_chapter {
    overflow: hidden;
    margin-top: 10px;
  }
  .signature_left_chapter p {
    margin: 0 10px;
  }
  .signature_left_chapter span {
    float: right;
  }
  .signature_right {
    border: 1px solid #999999;
    height: 60px;
    padding: 10px;
  }
  .signature_right h1 {
    font-size: 14px;
  }
  .footer {
    margin-top: 30px;
  }
  .footer p {
    font-size: 26px;
  }
  .footer span {
    font-size: 20px;
    text-align: right;
    display: block;
    margin-top: 30px;
  }
  .footer i {
    font-size: 20px;
    text-align: right;
    display: block;
    font-style: normal;
    display: block;
    margin-top: 12px;
  }
  .header {
    width: 1300px;
  }
  .header h1 {
    text-align: center;
  }
  .header p {
    font-size: 20px;
  }
  .header span {
    font-size: 20px;
    text-indent: 40px;
    display: block;
    margin: 20px 0 40px 0;
  }

  .tipsTop {
    margin: 20px 0 4px 0;
  }
  .tipsTop span {
    font-size: 16px;
    margin-right: 100px;
  }
</style>
<style>
  .table .cell {
    color: #111111;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/print.vue